import * as React from "react";
import moment from "moment";
import styles from "./testimonial.module.scss";
import ReactStars from "react-stars";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { staticTestimonialHero, staticTestimonialCta } from '../../utils'
import { countryFlagsUrl } from "../../config";

const Testimonial = ({
  review,
  error,
  loading,
  dynamic = true,
  variant,
}: {
  review: {
    reviewMessage: string;
    avatar: string;
    author: string;
    reviewRating: number;
    reviewTitle: string;
    reviewDate: string;
    location: string
  };
  error: any;
  loading: boolean;
  dynamic?: boolean
  variant?: 'hero' | 'cta'
}) => {

  const renderContent = () => {
    switch(variant) {
      case 'hero':
        return staticTestimonialHero
      case 'cta':
        return staticTestimonialCta
      default:
        return review
    }
  }
  
  const reviewToDisplay = dynamic ? renderContent() : review

  return (
    <div className={styles.testimonial}>
      <div className={styles.header}>
        <div className={styles.left}>
          <strong>{reviewToDisplay?.reviewTitle}</strong>
          <ReactStars
            className={styles.stars}
            value={reviewToDisplay?.reviewRating || 4.7}
            count={5}
            color2="#ffd203"
            color1="#ccc"
            edit={false}
          />
        </div>
        <p className={styles.date}>{moment(reviewToDisplay?.reviewDate).format('YYYY-MM-DD')}</p>
      </div>

      <p className={styles.text}>
        <span>"</span>
        {reviewToDisplay?.reviewMessage || "Loading..."}
        <span>"</span>
      </p>
      <div className={styles.author}>
        <div
          className={styles.avatar}
          style={{ backgroundImage: `url(${reviewToDisplay?.avatar})` }}
        />
        <div className={styles.name}>
          <h4>{reviewToDisplay?.author || "Loading..."}</h4>
          <h4 className={styles.location}>
            <img
              className={styles.flag}
              src={countryFlagsUrl(reviewToDisplay?.location.toLowerCase())}
              alt="Flag"
            />
            {reviewToDisplay?.location}
          </h4>
        </div>
          <h4 className={styles.verified}>
            <i>
              <FontAwesomeIcon icon={faCheck} />
            </i>{" "}
            <span>Verified buyer</span>
          </h4>
      </div>
    </div>
  );
};

export default Testimonial;